import axiosInstance from "../config/axiosInterceptor";

export async function getNodeSlotDefinition() {
  return await axiosInstance.get("/api/NodeSlotDefinition");
}

export async function getNodeSlotDefinitionById(id) {
  return await axiosInstance.get(`/api/NodeSlotDefinition/${id}`);
}

export async function postNodeSlotDefinition(nodeId, slotDefinitionTableId) {
  const payload = {
    idnodeSlotDefinition: 0,
    nodeId: nodeId,
    slotDefinitionTable_idslotDefinitionTable: slotDefinitionTableId,
    slotDefinitionTable_name: "string",
  };
  return await axiosInstance.post("/api/NodeSlotDefinition", payload);
}

export async function putNodeSlotDefinition(
  idnodeSlotDefinition,
  nodeId,
  slotDefinitionTableId
) {
  const payload = {
    idnodeSlotDefinition: idnodeSlotDefinition,
    nodeId: nodeId,
    slotDefinitionTable_idslotDefinitionTable: slotDefinitionTableId,
    slotDefinitionTable_name: "string",
  };
  return await axiosInstance.put("/api/NodeSlotDefinition", payload);
}

export async function deleteNodeSlotDefinition(idnodeSlotDefinition) {
  return await axiosInstance.delete(`/api/NodeSlotDefinition/${idnodeSlotDefinition}`);
}

export async function checkSlotDefinitionUsageInNodes(slotDefinitionId) {
  const nodeSlotDefinitions = await getNodeSlotDefinition();

  const usedInNodes = nodeSlotDefinitions.filter(
    (nsd) => nsd.slotDefinitionTable_idslotDefinitionTable === slotDefinitionId
  );

  return {
    isUsed: usedInNodes.length > 0,
    nodes: usedInNodes,
    count: usedInNodes.length,
  };
}
